import React from "react";
import { Fieldset } from "primereact/fieldset";
import { Message } from "primereact/message";
const Observation = (props) => {
  const { observationValue } = props;

  return (
    <>
      {observationValue && (
        <>
          <Fieldset legend="Observaciones" toggleable>
            <Message
              text={observationValue?.txtComentario ?? ""}
              severity="warn"
              style={{ textAlign: "justify" }}
            />
          </Fieldset>
          <div className="mb-2"></div>
        </>
      )}
    </>
  );
};
export default Observation;
